"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = () => ({
  // eslint-disable-line
  select: {
    position: 'relative'
  },
  edit: {
    '&:hover': {
      cursor: 'pointer'
    },
    '& .field': {
      alignItems: 'center',
      '& input': {
        textOverflow: 'ellipsis'
      }
    },
    '& input': {
      cursor: 'pointer'
    }
  },
  menu: {
    width: '100%',
    maxWidth: 'inherit',
    marginTop: '-20px',
    maxHeight: 200,
    '&.unspaced': {
      marginTop: 0
    } // TODO доработать открытие вверх

  },
  popover: {
    zIndex: 10000
  }
});

exports.default = _default;